import { Button, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useContext, useEffect, useState } from 'react';
import { ReservationContext } from '../../../contexts/reservation.context';
import Dish from '../../user/cart/user.cart.dish';
import DeliveryOrder from '../room/owner.room.deliveryOrder';

const useStyles = makeStyles((theme) => ({
    spacingTop: {
        marginTop: theme.spacing(2) + ' !important',
    },
    spacingBottom: {
        marginBottom: theme.spacing(2) + ' !important',
    },
    content: {
        padding: '10px',
    },
    centeredText: {
        marginTop: '60px',
        textAlign: 'center',
    },
}));

const UserCart = ({
    handleClickOrder,
    getAmountTotal,
    tableId,
    ownerId,
    setOpenDialog,
    openDialog,
    deliveryId,
    userId
}) => {
    const classes = useStyles();
    const { cart, getTotalPrice, successOrder, getDishPrice, order, orderRoomCart, eraseOrder } =
        useContext(ReservationContext);
    
    // Inizializziamo lo stato calcolando il prezzo immediatamente
    const [totalPrice, setTotalPrice] = useState(() => getTotalPrice());
    const [openDialogOrderDelivery, setOpenDialogOrderDelivery] = useState(false);

    // Gestione del ricalcolo del totale e comunicazione al padre
    useEffect(() => {
        const newTotal = getTotalPrice();
        setTotalPrice(newTotal);

        // Comunichiamo al padre solo se la funzione esiste
        if (getAmountTotal) {
            getAmountTotal(cart);
        }
        
        // Usiamo JSON.stringify(cart) come dipendenza "sicura" o monitoriamo la lunghezza
        // per evitare loop se le funzioni passate come props non sono memoizzate
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cart, cart.length]); 

    // Funzione per ordinare
    const _handleOrder = () => {
        if (tableId) {
            order({ tableId, ownerId });
            eraseOrder();
        } else {
            orderRoomCart({ deliveryId, ownerId, userId });
            eraseOrder();
        }
        handleClickOrder();
    }

    return (
        <>
            <DeliveryOrder
                setOpenDialogOrderDelivery={setOpenDialogOrderDelivery}
                openDialogOrderDelivery={openDialogOrderDelivery}
                cart={cart}
                totalPrice={totalPrice}
                getDishPrice={getDishPrice}
                ownerId={ownerId}
                openDialog={openDialog}
                setOpenDialog={setOpenDialog}
                handleClickOrder={handleClickOrder}
            />

            <div className={classes.content}>
                {cart && cart.length !== 0 ? (
                    <>
                        {cart.map((dish, i) => (
                            <React.Fragment key={`${dish.id}_${i}_${dish.amount}_${dish.note}`}>
                                <Dish dish={dish} dishIndex={i} isOwner={true} />
                            </React.Fragment>
                        ))}

                        {(tableId || deliveryId) ? (
                            <Button
                                variant='contained'
                                color='secondary'
                                fullWidth
                                className={`${classes.spacingTop} ${classes.spacingBottom}`}
                                onClick={_handleOrder}
                                disabled={successOrder}
                            >
                                Ordina {totalPrice.toFixed(2)}€
                            </Button>
                        ) : (
                            <Button
                                variant='contained'
                                color='secondary'
                                fullWidth
                                className={`${classes.spacingTop} ${classes.spacingBottom}`}
                                onClick={() => setOpenDialogOrderDelivery(!openDialogOrderDelivery)}
                                disabled={successOrder}
                            >
                                Concludi ordine ( {totalPrice.toFixed(2)} € )
                            </Button>
                        )}
                    </>
                ) : (
                    <Typography
                        variant='subtitle1'
                        color='textSecondary'
                        className={classes.centeredText}
                    >
                        Il carrello è vuoto.
                    </Typography>
                )}
            </div>
        </>
    );
};

export default UserCart;